module.exports = __webpack_public_path__ + "img/color-drop_jp.1cdd6d9.jpg";